module.exports = __webpack_public_path__ + "static/media/fukui.41fa16ea.png";